import {useFormik} from 'formik'
import {createDemandeTransfertVehicule} from '../../../../components/requests'
import {ModeleTransfertStatutVehicule} from '../../../../components/Models'
import React, {useState} from 'react'
import {TextInput} from '../../../../components/inputs/TextInput'
import {Button} from 'react-bootstrap'
import {useAuth} from '../../../modules/auth'
import * as Yup from 'yup'
import {toast} from 'react-toastify'

const TransfertStatutVehiculeForm = (props) => {
  const {showModalProp, vehiculeId, numeroVehicule, data, setData} = props
  const {currentUser} = useAuth()

  const initialValues: ModeleTransfertStatutVehicule = {
    vehiculeId: vehiculeId,
    demandeParId: currentUser?.id,
    commentaire: '',
  }

  const [loading, setLoading] = useState(false)

  const onSubmitHandler = (values) => {
    setLoading(true)
    const id = toast.loading('Envoi de la demande de transfert en cours...')
    createDemandeTransfertVehicule(values)
      .then((transfertStatutRequest) => {
        if (transfertStatutRequest?.status === 200) {
          if (transfertStatutRequest?.data !== undefined) {
            setLoading(false)
            showModalProp(false)
            const updatedData = data?.map(item => {
              if (item?.[0]?.id === transfertStatutRequest?.data?.vehicule?.id) {
                return {
                  ...item,
                  demandeTransfertValidePar: null,
                  valide: transfertStatutRequest?.data?.valide
                }
              } else {
                return item
              }
            })
            setData(updatedData)
            toast.update(id, {
              render: 'Demande de transfert envoyée avec succès',
              type: 'success',
              isLoading: false,
              autoClose: 4000,
            })
          } else {
            setLoading(false)
          }
        } else {
          setLoading(false)
        }
      })
      .catch((e) => {
        setLoading(false)
      })
  }

  const validationSchema = Yup.object().shape({
    commentaire: Yup.string().trim().required('Le commentaire est requis.'),
  })

  const formik = useFormik<ModeleTransfertStatutVehicule>({
    initialValues: initialValues,
    validationSchema: validationSchema,
    onSubmit: onSubmitHandler,
    validateOnBlur: true,
    validateOnChange: true,
  })

  return (
    <div>
      <form action='#' onSubmit={formik.handleSubmit}>
        <div className='App'>
          <div className='modal-body pt-3'>
            <div className='row'>
              <div className='col-sm-12'>
                <label className='col-lg-4 col-form-label required fw-bold fs-6'>Commentaire</label>
                <TextInput
                  fieldName={'commentaire'}
                  inputType={'text'}
                  inputClassName={'form-control form-control-lg mb-3 mb-lg-0'}
                  formik={formik}
                />
              </div>
            </div>
          </div>
          <div className='modal-footer'>
            <div className='row'>
              <div className='col-sm-12' style={{textAlign: 'right'}}>
                <Button variant='secondary me-5' onClick={() => showModalProp(false)}>
                  Annuler
                </Button>
                <Button
                  variant='info'
                  type='submit'
                  disabled={!formik.isValid || !formik.dirty || loading}
                >
                  {!loading && 'Confirmer'}
                  {loading && (
                    <span className='indicator-progress' style={{display: 'block'}}>
                      Confirmation...{' '}
                      <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                    </span>
                  )}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  )
}

export {TransfertStatutVehiculeForm}
